// Main Scripts
// ---------------------
import mainSlideshow from './js/widgets/mainSlideshow.js';
import eventCards from './js/widgets/eventCards.js';
import hotButtons from './js/widgets/hotButtons.js';
import seoWidget from './js/widgets/seoWidget.js';
import youtubeVideo from './js/widgets/youtubeVideo.js';
import * as socialNetworkWidget from './js/widgets/socialNetworkWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import gridGallerySmall from './js/widgets/gridGallerySmall.js';

// Secondary Scripts
// ---------------------
import './js/localjs.js';

$(document).ready(function () {
  if (window.location.pathname === '/') {
    mainSlideshow();
    eventCards();
    hotButtons();
    seoWidget();
    scrollerSponsors();
  }
  gridGallerySmall();
});

if (window.location.pathname === '/') {
  $(window).load(function () {
    youtubeVideo();
    socialNetworkWidget.facebookfeed(true);
  });
}
